var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIc26(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "11.0064mm",
    height: "9.6175mm",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 209.52 183.08",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    x: 2.16,
    y: 52.99,
    width: 205.24,
    height: 4.23
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    x: 2.16,
    y: 178.85,
    width: 205.24,
    height: 4.23
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    x: 66.23,
    y: 113.88,
    width: 21.15,
    height: 4.23
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M34.9 153.62c-0.01,-0 -0.03,-0 -0.05,-0 -19.25,0 -34.85,-15.61 -34.85,-34.85 0,-19.24 15.61,-34.85 34.85,-34.85 19.25,0 34.85,15.61 34.85,34.85 -0.02,19.22 -15.59,34.8 -34.8,34.85l-0 0zm0 -65.48c-16.91,0 -30.62,13.71 -30.62,30.62 0,16.91 13.71,30.62 30.62,30.62 16.91,0 30.62,-13.71 30.62,-30.62 -0.03,-16.9 -13.73,-30.59 -30.62,-30.62l-0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M42.96 134.18l-2.62 -8.61 -12.94 0 -2.57 8.61 -4.64 0 10.98 -34.25 5.84 0 10.93 34.25 -4.99 0zm-14.4 -12.44l10.68 0 -5.34 -17.88 -5.34 17.88z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_1993512262448"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#999999",
    fillRule: "nonzero",
    x: 107.28,
    y: 17.23,
    width: 4.23,
    height: 16.97
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#999999",
    fillRule: "nonzero",
    x: 107.28,
    y: 45.43,
    width: 4.23,
    height: 19.29
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#999999",
    fillRule: "nonzero",
    x: 107.28,
    y: 75.95,
    width: 4.23,
    height: 16.97
  })), /*#__PURE__*/React.createElement("g", {
    id: "_1993512267200"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#999999",
    fillRule: "nonzero",
    x: 183.94,
    y: 17.23,
    width: 4.23,
    height: 16.97
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#999999",
    fillRule: "nonzero",
    x: 183.94,
    y: 45.43,
    width: 4.23,
    height: 19.29
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#999999",
    fillRule: "nonzero",
    x: 183.94,
    y: 75.95,
    width: 4.23,
    height: 16.97
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    x: 112.31,
    y: 15.11,
    width: 70.81,
    height: 4.23
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M171.19 34.5l-2.97 -3.02 14.25 -14.25 -14.25 -14.25 2.97 -2.97 17.28 17.23 -17.28 17.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M124.1 34.5l-17.28 -17.28 17.28 -17.23 2.97 2.97 -14.25 14.25 14.25 14.25 -2.97 3.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M109.39 139.46c-12.96,0 -23.47,-10.51 -23.47,-23.47 0,-12.96 10.51,-23.47 23.47,-23.47 12.9,0 23.39,10.42 23.47,23.32 0,0.05 0,0.1 0,0.15 0,12.96 -10.51,23.47 -23.47,23.47 0,0 0,0 0,0l0 0zm0 -42.66c-10.62,-0 -19.24,8.61 -19.24,19.24 0,10.62 8.62,19.24 19.23,19.24 10.62,0 19.24,-8.62 19.24,-19.24 0,-0.07 0,-0.14 0,-0.2 -0.11,-10.55 -8.69,-19.04 -19.24,-19.04 0,0 0,0 0,0l0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M186.05 139.46c-12.96,0 -23.47,-10.51 -23.47,-23.47 0,-12.96 10.51,-23.47 23.47,-23.47 12.9,0 23.39,10.42 23.47,23.32 0,0.05 0,0.1 0,0.15 0,12.96 -10.51,23.47 -23.47,23.47 0,0 0,0 0,0l0 0zm0 -42.66c-10.63,-0 -19.24,8.61 -19.24,19.24 0,10.62 8.62,19.24 19.24,19.24 10.62,0 19.24,-8.62 19.24,-19.24 0,-0.07 0,-0.14 0,-0.2 -0.11,-10.55 -8.69,-19.04 -19.24,-19.04 0,0 0,0 0,0l0 0z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    x: 130.75,
    y: 113.88,
    width: 34,
    height: 4.23
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc26);
export default __webpack_public_path__ + "static/media/ic_2_6.6b85a374b63efa61b6e54cfccadeb5ba.svg";
export { ForwardRef as ReactComponent };